import React, { useEffect, useState } from 'react'
import UserLayout from '../../../components/layouts/UserLayout'
import CameraIcon from '../../../components/elements/icons/CameraIcon'
import { authHeader, tableHeadersFields, toTimeStamp, transactionTimeStamp } from '../../../utils';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR } from '../../../store/types';
import Loader from '../../../components/elements/Loader';
import { Link, useParams } from 'react-router-dom';
import ApplicationStatus from '../../../components/elements/ApplicationStatus';
import DocumentPreview from '../../../components/elements/DocumentPreview';
import DocumentRequest from '../../../components/elements/DocumentRequest';
import DataTable from '../../../components/elements/DataTable';
import ScheduledExamination from '../../../components/partials/applications/ScheduledExamination';
import { fetchDocumentRequests } from '../../../store/actions/documentRequestActions';
import ChevronIcon from '../../../components/elements/icons/ChevronIcon';
import ArrowIcon from '../../../components/elements/icons/ArrowIcon';
import ModalDialog from '../../../components/layouts/ModalDialog';
import ApplicationResponse from '../../../components/partials/applications/application-responses/ApplicationResponse';
import NewApplicationResponse from '../../../components/partials/applications/application-responses/NewApplicationResponse';
import { fetchApplicationResponses } from '../../../store/actions/applicationResponsesActions';
import InlinePreloader from '../../../components/elements/InlinePreloader';
import ArrowDownTrayIcon from '../../../components/elements/icons/ArrowDownTrayIcon';

const Application = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true);
  const [application, setApplication] = useState(null);
  const [fee, setFee] = useState(null);
  const { applicationId } = useParams()
  const documentRequestsSelector = useSelector(state => state.documentRequests)
  const responsesSelector = useSelector(state => state.applicationResponses)
  const [reload, setReload] = useState(0);
  const [admissionOffers, setAdmissionOffers] = useState([]);
  const [loadingOffers, setLoadingOffers] = useState(false);
  const [father, setFather] = useState(null);
  const [mother, setMother] = useState(null);

  useEffect(() => {
    dispatch(fetchDocumentRequests(`application=${applicationId}`))
    dispatch(fetchApplicationResponses(applicationId, ``, 0, 0))
    const fetchApplication = async () => {
      try {
        const headers = authHeader()

          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/applications/${applicationId}?expand=admission,payment,scheduledExaminations.examination,scheduledExaminations.center,preferredCenter,parent`, { headers })            

          setApplication(response.data.data)

          setFather(response.data.data.parentRelationship === 'FATHER' ? response.data.data.parent : response.data.data.applicantFather )
          setMother(response.data.data.parentRelationship === 'MOTHER' ? response.data.data.parent : response.data.data.applicantMother )

          if(response.data.data?.payment?.fee) {
            fetchFee(response.data.data.payment.fee)
          } else {
            setLoading(false)
          }
          if(response.data.data.status === 'PROVISIONAL_OFFER') {
            setLoadingOffers(true)
            fetchOffers()
          }
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setLoading(false)
        }
    }

    const fetchFee = async (feeId) => {
      try {
        const headers = authHeader()

          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/fees/${feeId}`, { headers })            

          setFee(response.data.data)
          setLoading(false)
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setLoading(false)
        }
    }

    const fetchOffers = async () => {
      try {
        const headers = authHeader()

          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admission-offers?application=${applicationId}`, { headers })            

          setAdmissionOffers(response.data.data.admissionOffers)
          console.log(response.data.data.admissionOffers)
          setLoadingOffers(false)
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setLoadingOffers(false)
        }
    }


    fetchApplication()
    return () => {
      
    };
  }, [dispatch, applicationId, reload]);

  const tableOptions = {
    selectable: false,
    expandable: false,
    clickableRows: false,
    rowAction: (value)=>{}
  }

  const columnWidths = {
    school: "w-full lg:w-5/12",
    from: "w-full lg:w-1/12",
    to: "w-full lg:w-1/12",
    schoolType: "w-full lg:w-3/12",
    latestClass: "w-full lg:w-2/12",
  }

  const cleanupData = (dataSet) => {
    const data = []
    if (!dataSet) return []

    dataSet.forEach((item, itemIndex) => {
      data.push({
        school: <p>{item.school} {item.current ? <span className='text-xs text-green-800 bg-green-500 bg-opacity-10 px-2 py-1 rounded ml-2'>Current</span> : ''}</p>,
        from: item.fromYear,
        to: item.toYear,
        schoolType: <p className='capitalize'>{item.type?.toLowerCase()} School</p>,
        latestClass: item.latestClass
      })
    })

    return data
  }

  const [responding, setResponding] = useState(false);
  const [responseOpen, setResponseOpen] = useState(false);
  const [activeResponse, setActiveResponse] = useState(null);

  const openMessage = (message) => {
    setActiveResponse(message)
    setTimeout(() => {
      setResponseOpen(true)
    }, 50);
  }

  const closeMessage = () => {
    setResponseOpen(false)
    setTimeout(() => {
      setActiveResponse(null)
    }, 50);
  }

  const [savingPdf, setSavingPdf] = useState(false)

  // download application as pdf
  const downloadApplication = async () => {
    try {
      const headers = authHeader()
      setSavingPdf(true)

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/applications/${applicationId}/export/pdf`,
        { 
          headers,
          responseType: 'blob'
        }
      )
      
      // Create a blob URL
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      
      // Create a temporary link and trigger download
      const link = document.createElement('a')
      link.href = url
      link.download = `application-${application.applicationCode}.pdf`
      document.body.appendChild(link)
      link.click()
      
      // Cleanup
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      setSavingPdf(false)

    } catch (error) {
      console.log('error downloading application: ', error)
      dispatch({
        type: ERROR,
        error
      })
      setSavingPdf(false)

    }
  }

  return (
    <>
      <UserLayout>
        <div className='w-full py-8'>
          {loading ? 
            <Loader />
            :
            <div className='w-full lg:flex items-start justify-between gap-x-5'>
              <div className='w-full lg:w-9/12'>
                <div className='w-full lg:flex items-start gap-x-5'>
                  <div className='w-full lg:w-3/12'>
                    <div className='bg-gray-50 h-[500px] lg:h-[250px] rounded-[8px] flex items-center justify-center' style={{
                      backgroundImage: `url(" ${application?.passportPhotograph} ")`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'top center',
                      backgroundRepeat: 'none'
                    }}>
                        {(!application?.passportPhotograph || application?.passportPhotograph === '') &&
                            <CameraIcon className={`w-8 h-8 text-gray-300`} />
                        }
                    </div>

                    <div className='w-full my-5'>
                      <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>admission applied for</label>
                      <p className='text-gray-600'>{application.admission.title} - {application.admission.type}</p>
                    </div>

                    <div className='w-full my-5'>
                      <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>class</label>
                      <p className='text-gray-600'>{application.class}</p>
                    </div>

                    <div className='w-full mt-5 mb-2'>
                      <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>application status</label>
                      {/* <p className='text-gray-600'>{application.class}</p> */}
                      <ApplicationStatus status={application.status} />
                    </div>

                    {!loadingOffers && admissionOffers.length > 0 &&
                    <Link to={`/user/admission-offers/${admissionOffers[0]._id}`}>
                      <button className='text-vcm-purple font-medium hover:text-gray-500 transition duration-200 text-xs flex items-center gap-x-2'>View admission offer details <ChevronIcon className={`w-4 h-4 rotate-180`} /></button>
                    </Link>
                    } 
                  </div>
                  <div className='w-full lg:w-9/12 lg:px-4 mt-12 lg:mt-0'>
                    <p className='uppercase tracking-[0.2em] text-sm text-vcm-purple'>application details</p>

                    <div className='w-full mt-5'>
                      <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Application number</label>
                      <div className='flex items-center gap-x-2'>
                        <h3 className='font-medium font-orbitron'>{application.applicationCode}</h3>
                        <div className='flex items-center gap-x-[5px]'>
                          {application.completed && <button onClick={downloadApplication} disabled={savingPdf} className='rounded-[8px] w-[30px] h-[30px] text-sm text-gray-600 bg-transparent transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2'>
                            {savingPdf 
                              ?
                                <InlinePreloader />
                              :
                                <ArrowDownTrayIcon className='w-4 h-4' />
                            }

                          </button>}
                          {/* <button onClick={()=>{setRejectingApplication(true)}} className='rounded-[8px] w-[30px] h-[30px] text-sm text-gray-600 bg-transparent transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2'>
                            <PrinterIcon className='w-4 h-4' />
                          </button> */}
                          
                        </div>
                      </div>
                    </div>

                    <div className='lg:flex items-start gap-x-5 justify-between my-8'>
                      <div className='w-full'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>first name</label>
                        <p className='text-gray-600'>{application.firstName}</p>
                      </div>
                      <div className='w-full mt-6 lg:mt-0'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>other name(s)</label>
                        <p className='text-gray-600'>{application.otherNames}</p>
                      </div>
                      <div className='w-full mt-6 lg:mt-0'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>last name</label>
                        <p className='text-gray-600'>{application.lastName}</p>
                      </div>
                    </div>
                    <div className='lg:flex items-start gap-x-5 justify-between my-8'>
                      <div className='w-full mt-6 lg:mt-0'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>date of birth</label>
                        <p className='text-gray-600'>{transactionTimeStamp(application.dob).date}</p>
                      </div>
                      <div className='w-full mt-6 lg:mt-0'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Gender</label>
                        <p className='capitalize text-gray-600'>{application.gender?.toLowerCase() || ''}</p>
                      </div>
                      <div className='w-full mt-6 lg:mt-0'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Religion</label>
                        <p className='text-gray-600'>{application.religion}</p>
                      </div>
                    </div>
                    <div className='flex items-start gap-x-5 justify-between my-8'>
                        <div className='w-full'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>nationality</label>
                        <p className='text-gray-600'>{application.nationality}</p>
                        </div>
                        <div className='w-full'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>state of origin</label>
                        <p className='capitalize text-gray-600'>{application.state}</p>
                        </div>
                        <div className='w-full'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>lga</label>
                        <p className='text-gray-600'>{application.lga}</p>
                        </div>
                    </div>
                    <div className='flex items-start gap-x-5 justify-between my-8'>
                        <div className='w-full'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>tribe</label>
                        <p className='text-gray-600'>{application.tribe}</p>
                        </div>
                        <div className='w-full'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Spoken languages</label>
                        <p className='capitalize text-gray-600'>{application.languages.join(', ')}</p>
                        </div>
                        <div className='w-full'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Complexion</label>
                        <p className='text-gray-600 capitalize'>{application.complexion?.toLowerCase() || ''}</p>
                        </div>
                    </div>

                    <div className='lg:flex items-start gap-x-5 justify-between my-8'>
                      <div className='w-full mt-6 lg:mt-0'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>mother's maiden name</label>
                        <p className='text-gray-600'>{application.mothersMaidenName}</p>
                      </div>
                      <div className='w-full mt-6 lg:mt-0'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>father's name</label>
                        <p className='text-gray-600'>{application.fathersName}</p>
                      </div>
                      <div className='w-full mt-6 lg:mt-0'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>number of siblings</label>
                        <p className='text-gray-600'>{application.numberOfSiblings}</p>
                      </div>
                    </div>

                    <div className='lg:flex items-start gap-x-5 justify-between my-8'>
                      <div className='w-full mt-6 lg:mt-0'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>sports interests</label>
                        <p className='text-gray-600'>{application.sportsInterests.join(', ')}</p>
                      </div>
                    </div>
                    <div className='lg:flex items-start gap-x-5 justify-between my-8'>
                      <div className='w-full mt-6 lg:mt-0'>
                        <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>hobbies</label>
                        <p className='text-gray-600'>{application.hobbies.join(', ')}</p>
                      </div>
                    </div>

                    {application.parentRelationship && <div className='p-5 bg-gray-50 border border-gray-300 rounded-[8px]'>
                          <label className='text-sm tracking-[0.2em] uppercase text-gray-800 font-[550] mb-4 block'>applicant's parents</label>
                          {application.parentRelationship && <p className='text-sm mt-2'>Application was created by applicant's <span className='capitalize font-[550]'>{application.parentRelationship === 'OTHER' ? 'Guardian:' : application.parentRelationship?.toLowerCase()}</span></p>}
                          {application.parentRelationship === 'OTHER' && 
                            <div className='mb-6'>
                              <p className='text-sm'><span className='capitalize font-[550]'>{`${application.parent.firstName} ${application.parent.lastName}`}</span> - {application.parent.phone}, {application.parent.email}</p>
                              <button className='flex items-center gap-x-1 text-xs text-gray-400 transition duration-200 hover:text-vcm-purple'>See guardian's profile <ArrowIcon className={`w-4 h-4`} /></button>
                            </div>
                          }
                          <div className='lg:flex items-start gap-x-5 justify-between my-3'>
                            <div className='w-full'>
                              {father !== null && <>
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Father's name</label>
                                <p className='text-gray-600 mb-8'>{father?.name || `${father?.firstName} ${father?.lastName}`}</p>
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Father's occupation</label>
                                <p className='text-gray-600 mb-8'>{father?.occupation}</p>
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Father's work address</label>
                                <p className='text-gray-600 mb-8'>{father?.workAddress || `${father?.employment?.address}, ${father?.employment?.city}, ${father?.employment?.state}`}</p>
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Father's home address</label>
                                <p className='text-gray-600 mb-8'>{father?.homeAddress || `${father?.address?.address}, ${father?.address?.city}, ${father?.address?.state}`}</p>
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Father's Contact details</label>
                                <p className='text-gray-600 mb-8'>{father?.phone || ''}, {father?.email || ''}</p>
                              </>}
                            </div>
                            <div className='w-full'>
                            {mother !== null && <>
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>mother's name</label>
                                <p className='text-gray-600 mb-8'>{mother?.name || `${father?.firstName} ${mother?.lastName}`}</p>
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>mother's occupation</label>
                                <p className='text-gray-600 mb-8'>{mother?.occupation}</p>
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>mother's work address</label>
                                <p className='text-gray-600 mb-8'>{mother?.workAddress || `${mother?.employment?.address}, ${mother?.employment?.city}, ${mother?.employment.state}`}</p>
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>mother's home address</label>
                                <p className='text-gray-600 mb-8'>{mother?.homeAddress || `${mother?.address?.address}, ${mother?.address?.city}, ${mother?.address?.state}`}</p>
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>mother's Contact details</label>
                                <p className='text-gray-600 mb-8'>{mother?.phone || ''}, {mother?.email || ''}</p>
                              </>}
                            </div>
                          </div>
                        </div>}

                    <div className='py-4 border-t border-b'>
                      <div className='flex items-end gap-x-5 justify-between'>
                        <div className='w-2/3'> 
                          <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Amount paid</label>
                          <p className='capitalize text-gray-600 text-lg'>₦{((fee?.amount/100) || 0).toLocaleString()} {application.payment && <span className='text-xs'>on {transactionTimeStamp(application.payment.createdAt).date} : {transactionTimeStamp(application.payment.createdAt).time}  </span>}</p>
                        </div>

                        {/* <div className='w-1/3'>
                          <ApplicationStatus status={application.status} />
                        </div> */}
                      </div>

                    </div>

                    {application.additionalInformation && application.additionalInformation !== '' && <div className='py-4 border-t border-b'>
                      <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Additional Information</label>
                      <p className='capitalize text-gray-600 text-sm'>{application.additionalInformation}</p>
                    </div>}

                    {application.supportingDocuments && <DocumentPreview document={{
                      name: "Supporting Document",
                      url:application.supportingDocuments}} 
                    />}

                    
                  </div>
                </div>

                <div className='my-12'>
                  <p className='uppercase tracking-[0.2em] text-sm text-vcm-purple'>Schools attended</p>

                  <div className='w-full'>
                    <DataTable
                      tableHeaders={tableHeadersFields(cleanupData(application.schoolsAttended)[0]).headers} 
                      tableData={cleanupData(application.schoolsAttended)} 
                      columnWidths={columnWidths}
                      columnDataStyles={{}}
                      allFields={tableHeadersFields(cleanupData(application.schoolsAttended)[0]).fields}
                      onSelectItems={()=>{}}
                      tableOptions={tableOptions}
                      pagination={null}
                      changePage={()=>{}}
                      updatePerPage={()=>{}}
                      expandedIndex={''}
                      expansion={null}
                    />
                  </div>
                </div>

              </div>
              <div className='w-full lg:w-3/12 min-h-[800px] h-inherit bg-gray-100 rounded-md p-5 -mt-5'>
                
                {application.scheduledExaminations && application.scheduledExaminations.length > 0 && 
                <>
                  <p className='uppercase tracking-[0.2em] text-xs mt-3 text-vcm-purple'>Scheduled examinations</p>
                  <div className='my-5'>
                    {application.scheduledExaminations.map((exam, examIndex) => (
                      <div key={examIndex}>
                        <ScheduledExamination exam={exam} />
                      </div>
                    ))}
                  </div>
                </>
                }

                {application.preferredCenter && <div className='bg-vcm-light-purple bg-opacity-20 border border-vcm-purple border-opacity-50 p-4 rounded-[8px] mt-5'>
                  <label className='text-xs tracking-[0.2em] uppercase text-black mb-2 block'>Preferred Examination Center</label>
                  <p className='capitalize text-gray-600 font-[550] text-[15px]'>{application.preferredCenter.name}</p>
                  <p className='capitalize text-gray-800 text-xs'>{application.preferredCenter.address}, {application.preferredCenter.city}, {application.preferredCenter.state}</p>
                </div>}
                
                <p className='uppercase tracking-[0.2em] text-xs mt-8 text-vcm-purple'>documents</p>

                <div className='my-5'>
                  {application.documents.map((doc, docIndex) => (
                    <div className='my-5' key={docIndex}>
                      <DocumentPreview document={doc} />
                    </div>
                  ))}
                </div>

                <p className='uppercase tracking-[0.2em] text-xs mt-8 text-vcm-purple'>document requests</p>

                {documentRequestsSelector?.documentRequests?.documentRequests && documentRequestsSelector?.documentRequests?.documentRequests?.filter(doc => {return doc.status === 'PENDING'}).length > 0 
                ? 
                
                <div className='my-5'>
                  {documentRequestsSelector.documentRequests?.documentRequests?.filter(doc => {return doc.status === 'PENDING'}).map((doc, docIndex) => (
                    <div className='my-5' key={docIndex}>
                      <DocumentRequest documentRequest={doc} reload={()=>{setReload(reload+1)}} />
                    </div>
                  ))}
                </div> 
                
                : 

                <p className='text-xs text-gray-400 mt-3'>No pending document requests for this application at this time. Any requests will show up here.</p>
                
                }


                <p className='uppercase tracking-[0.2em] text-xs mt-8 text-vcm-purple'>Responses & Messages</p>

                  {responsesSelector.loadingResponses ? <Loader /> : <>
                    {responsesSelector?.responses.responses && responsesSelector?.responses.responses?.length > 0 
                      ? 
                        <div className='my-5'>
                          {responsesSelector?.responses.responses?.map((response, responseIndex) => (
                            <div className='py-5 border-b border-gray-300' key={responseIndex}>
                              {/* <DocumentRequest document={doc} /> */}
                              <p className='text-sm text-gray-500'>{response.excerpt}...</p>
                              <p className='text-gray-600 text-sm mt-2'>{response.createdBy.name} - {toTimeStamp(response.createdAt)}</p>
                              <p className='text-sm text-gray-600'>{response.responses.length} replies</p>

                              <button onClick={()=>{openMessage(response)}} className='text-gray-400 mt-3 hover:text-vcm-purple transition duration-200 text-xs flex items-center gap-x-2'>View/Reply <ChevronIcon className={`w-4 h-4 rotate-180`} /></button>

                            </div>
                          ))}
                        </div> 
                      : 
                        <p className='text-xs text-gray-400 mt-3'>No responses on your application yet. Any new responses will be recorded here.</p>
                    }
                  </>}
                  {/* <button onClick={()=>{setResponding(true)}} className='rounded px-3 py-3 bg-vcm-purple text-sm text-white transition duration-200 mt-6 hover:bg-black'>New Response</button> */}
              </div>
            </div>
          }
        </div>
      </UserLayout>

      <ModalDialog
        shown={responding} 
        closeFunction={()=>{setResponding(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Create a response'
        maxWidthClass='max-w-3xl'
        hideActions={true}
      >
          <NewApplicationResponse 
            description={<p>Please provide a response to this application below.</p>} 
            application={application}
            reload={()=>setReload(reload+1)}
            closeFunction={()=>{setResponding(false)}} 
          />

      </ModalDialog>

      {activeResponse !== null && <ModalDialog
        shown={responseOpen} 
        closeFunction={()=>{closeMessage()}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Application response'
        maxWidthClass='max-w-3xl'
        hideActions={true}
      >
          <ApplicationResponse
            description={<p>Please see full response below. You can respond to this thread by clicking on "add a reply" below</p>} 
            application={application}
            parentResponse={activeResponse}
            reload={()=>setReload(reload+1)}
            closeFunction={()=>{setResponding(false)}} 
          />

      </ModalDialog>}
    </>
  )
}

export default Application